import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, strokeWidth }) => (
  <g
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m69.59 68.856a96.114 117.57 0 0 1 116.82-0.11108" />
    <path d="m98.178 97.926a49.072 59.961 0 0 1 59.644-0.05665" />
    <path d="m109.06 156.71-28.641-0.16458-3.1275 25.349c2.8295 1.6034 8.6552-3.7815 16.012-3.8622 7.2535-0.0796 17.107 5.7147 16.463 17.948-0.52267 9.9257-6.5438 14.915-12.962 16.836-7.4747 2.2364-14.84 0.0873-19.504-3.4189" />
    <path d="m174.2 158.87s-10.31-4.5261-20.654-2.4519c-10.966 2.199-22.001 11.493-22.001 29.715 0 14.123 12.771 23.6 21.248 25.993 13.475 3.8032 24.744-3.825 24.744-3.825v-20.852h-15.988" />
  </g>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} />],
    ['fill', <Icon color={color} strokeWidth={16} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const FiveG = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

FiveG.displayName = 'FiveG';
